import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'



import BoxButton from '../Layout/BoxButton'
import BoxSection from '../Layout/BoxSection'
import ModalAddFile from '../Shared/ModalAddFile'
import ModalAddTiquete from './ModalAddTiquete'


import { 
    displayModalAddTiquete, 
    addFile,
} from '../../actions/tiquetesaereo'


import { 
    displayModalAddFile, 
    downloadFile
} from '../../actions/common'

import { isAllowedToViewComponent } from '../../utils/helpers'


class Tiquetes extends Component {

	render() {
        
        const { id, tiquetesaereo } = this.props
        if (!id) return null


        const tipo_trayecto = tiquetesaereo.getIn(['viaje', 'tipo_trayecto'])
        
        return ( 
        <Fragment>

            <BoxSection title="Registro de tiquetes">

                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-tiquetes">                                    
                    <thead>
                        <tr>
                            <th style={{ width: '30px' }}></th>
                            <th style={{ width: '6%', textAlign: 'center' }}>No.Pasaj.</th>
                            <th>No. Tiquete</th>
                            <th style={{ width: '8%' }}>Valor tiquete</th>
                            <th>Fecha compra</th>
                            <th style={{ width: '10%' }}>Aerolínea/Proveedor</th>
                            <th style={{ width: '40%' }}>Trayectos</th>
                            {
                                tiquetesaereo.get('estado') == 4 ? <th>Adjuntar tiquete</th> : <th>Descargar tiquete</th>
                            }
                            
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (tiquetesaereo.getIn(['viaje', 'pasajeros']).count() > 0) &&
                                tiquetesaereo.getIn(['viaje', 'pasajeros']).map((x, n) => {

                                    const fileid = x.getIn(['tiquete', 'adjunto']) ? x.getIn(['tiquete', 'adjunto', 'id']) : null
                                    const filename = x.getIn(['tiquete','adjunto', 'nombre']) ? x.getIn(['tiquete', 'adjunto', 'nombre']) : null

                                    return (                                        
                                        <tr key={ `tr[${n}]`}>
                                            <td style={{ textAlign: 'center' }}><BoxButton size={ 12 } name="pencil" onClick={ () => this.props.displayModalAddTiquete(true, 'Agregar tiquete', n) } disabled={ tiquetesaereo.get('estado')!=4 || !isAllowedToViewComponent('responsable_compras', tiquetesaereo) }/></td>
                                            <td className="text-right">{n+1}</td>
                                            <td>{x.getIn(['tiquete', 'numero_tiquete'])}</td>
                                            <td className="text-right">{numeral(x.getIn(['tiquete', 'valor_pagado'])).format('$0,0.00')}</td>
                                            <td>{x.getIn(['tiquete', 'fecha_compra']) ? moment(x.getIn(['tiquete', 'fecha_compra'])).format('DD/MM/YYYY') : '' }</td>
                                            <td>{x.getIn(['tiquete', 'aerolinea'])}</td>  

                                            <td>
                                                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                                                    <thead>
                                                        <tr>
                                                            <th>Orígen</th>
                                                            <th>Fecha salida</th>
                                                            <th>Destino</th>
                                                            {
                                                                (tipo_trayecto == 1) && (
                                                                    <th>Fecha regreso</th>
                                                                )
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            x.getIn(['tiquete', 'itinerarios']).map((t,ti) => {
                                                                return(
                                                                    <tr key={`ite[${n}][${ti}]`}>
                                                                        <td>{`${t.get('origen')}-${t.get('aeropuerto_origen')}`}</td>
                                                                        <td>{ moment(t.get('fecha_salida')).format('DD/MM/YYYY hh:mm A') }</td>
                                                                        <td>{`${t.get('destino')}-${t.get('aeropuerto_destino')}`}</td>
                                                                        {
                                                                            (tipo_trayecto == 1) && (
                                                                                <td>{ moment(t.get('fecha_llegada')).format('DD/MM/YYYY hh:mm A') }</td>
                                                                            )
                                                                        }
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>                                                
                                                </table>                                                
                                            </td>  

                                            {
                                                tiquetesaereo.get('estado') == 4 ? (
                                                    <td>
                                                        {x.getIn(['tiquete', 'adjunto']) ? `${x.getIn(['tiquete', 'adjunto', 'nombre'])}` : 'Archivo sin adjuntar'}
                                                    </td>
                                                ) : (
                                                    <td style={{ cursor: 'pointer' }} onClick={ (x.getIn(['tiquete', 'adjunto'])) ? () => this.props.downloadFile(fileid, filename) : () => null }>
                                                        <i className="fa fa-download"></i>
                                                        <span style={{ marginLeft: '3px' }}>{`${x.getIn(['tiquete', 'adjunto', 'nombre'])}`}</span>                                                        
                                                    </td>
                                                )
                                            }
                                        </tr>
                                    )                                    
                                })
                        }
                    </tbody>
                </table>
            
            </BoxSection>

            <ModalAddTiquete displayModalAddFile={ this.props.displayModalAddFile }/>

            <ModalAddFile
                action={ () => this.props.addFile('modalAddTiquete.data.tiquete.adjunto') }
            />


        </Fragment> 
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.tiquetesaereo.get('id'),
        tiquetesaereo: state.tiquetesaereo.get('solicitud')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        displayModalAddTiquete: (show, title, index) => dispatch(displayModalAddTiquete(show, title, index)), 
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        addFile: (path) => dispatch(addFile(path)), 
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tiquetes)


// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/Tiquetes.jsx